
export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">About Me</h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-start">
          <div className="space-y-6">
            <p className="text-lg text-gray-700 leading-relaxed">
              I am a Sr. UX Designer with over 12 years of experience in UI/UX design. My focus is on creating user-centered digital experiences that solve complex problems with simplicity and clarity. I specialize in designing applications for the health & medical domain, construction industry, QMS, and asset management.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              Throughout my career, I've worked with diverse teams and stakeholders to deliver enterprise-level solutions that prioritize user needs while meeting business objectives. My approach combines thorough research, iterative design, and close collaboration with development teams.
            </p>
          </div>

          <div className="space-y-8">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Education</h3>
              <div className="space-y-4">
                <div className="flex gap-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-graduation-cap-line text-blue-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">B.Sc. Computer Science</h4>
                    <p className="text-gray-600">Andhra University • 2007</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-palette-line text-teal-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Diploma in Multimedia</h4>
                    <p className="text-gray-600">Datapro Institute • 2 years</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-award-line text-blue-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">UX Design Certification</h4>
                    <p className="text-gray-600">Graphics Guruji • 2025</p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Career Goals</h3>
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <i className="ri-arrow-right-s-line text-blue-600"></i>
                  <span className="text-gray-700">Senior UI/UX Designer</span>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ri-arrow-right-s-line text-blue-600"></i>
                  <span className="text-gray-700">Business Intelligence Developer</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
